document.addEventListener('DOMContentLoaded', function () {
  initVariantFilter();
});

function initVariantFilter() {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  // Recoge los datos de variantes desde el JSON del producto
  const productJson = document.querySelector('[data-product-json], #ProductJson-product-template, script[type="application/json"][data-product-json]');
  if (!productJson) {
    console.warn('No se encontró el JSON del producto');
    return;
  }

  let product;
  try {
    product = JSON.parse(productJson.textContent);
  } catch (e) {
    console.warn('Error parseando JSON del producto', e);
    return;
  }

  const variants = product.variants;
  const options = product.options; // ['Tipo', 'Formato', 'Tamaño']
  const selects = form.querySelectorAll('select[name^="options"]');

  if (selects.length < 2) return; // Solo actúa si hay más de 1 opción

  selects.forEach((select, index) => {
    select.addEventListener('change', () => filterOptions(selects, variants, index));
  });

  // Filtrado inicial
  filterOptions(selects, variants, 0);
}

function filterOptions(selects, variants, changedIndex) {
  // Para cada select posterior al que cambió, recalcula opciones válidas
  for (let i = changedIndex + 1; i < selects.length; i++) {
    const currentSelect = selects[i];
    const currentValue = currentSelect.value;

    // Construye el filtro con las selecciones anteriores
    const selectedBefore = Array.from(selects).slice(0, i).map(s => s.value);

    // Opciones válidas para esta posición dado lo seleccionado antes
    const validOptions = new Set();
    variants.forEach(variant => {
      const variantOptions = [variant.option1, variant.option2, variant.option3].slice(0, selects.length);
      const matchesBefore = selectedBefore.every((val, idx) => variantOptions[idx] === val);
      if (matchesBefore && variant.available) {
        validOptions.add(variantOptions[i]);
      }
    });

    // Actualiza las opciones del select
    Array.from(currentSelect.options).forEach(option => {
      if (option.value === '') return; // placeholder
      const isValid = validOptions.has(option.value);
      option.hidden = !isValid;
      option.disabled = !isValid;
    });

    // Si el valor actual ya no es válido, selecciona el primero disponible
    if (!validOptions.has(currentValue)) {
      const firstValid = Array.from(currentSelect.options).find(o => !o.hidden && o.value !== '');
      if (firstValid) {
        currentSelect.value = firstValid.value;
        currentSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
}
